import React from 'react';
import { motion } from 'framer-motion';

export const AnimatedGradient: React.FC = () => {
  return (
    <div className="absolute inset-0 z-0 overflow-hidden">
      {/* Base gradient background */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-br from-cyan-50 via-teal-50 to-blue-50"
        animate={{
          background: [
            "linear-gradient(135deg, #f0fdfa 0%, #f0fdf4 50%, #f0f9ff 100%)",
            "linear-gradient(135deg, #ecfeff 0%, #f0fdfa 50%, #f0fdf4 100%)",
            "linear-gradient(135deg, #f0f9ff 0%, #ecfeff 50%, #f0fdfa 100%)",
            "linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 50%, #ecfeff 100%)",
            "linear-gradient(135deg, #f0fdfa 0%, #f0fdf4 50%, #f0f9ff 100%)"
          ]
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      {/* Animated floating orbs */}
      <motion.div
        className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-cyan-400/40 to-teal-500/40 rounded-full blur-3xl"
        animate={{
          x: [0, 150, 0],
          y: [0, -80, 0],
          scale: [1, 1.5, 1],
          opacity: [0.4, 0.8, 0.4]
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      <motion.div
        className="absolute top-3/4 right-1/4 w-80 h-80 bg-gradient-to-r from-teal-400/40 to-cyan-300/40 rounded-full blur-3xl"
        animate={{
          x: [0, -120, 0],
          y: [0, 90, 0],
          scale: [1, 1.3, 1],
          opacity: [0.5, 0.9, 0.5]
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1
        }}
      />

      <motion.div
        className="absolute bottom-1/4 left-1/3 w-72 h-72 bg-gradient-to-r from-cyan-300/40 to-teal-400/40 rounded-full blur-3xl"
        animate={{
          x: [0, 100, 0],
          y: [0, -60, 0],
          scale: [1, 1.4, 1],
          opacity: [0.3, 0.7, 0.3]
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 2
        }}
      />

      {/* Subtle wave-like motion */}
      <motion.div
        className="absolute top-1/2 right-1/3 w-64 h-64 bg-gradient-to-r from-cyan-200/15 to-teal-300/15 rounded-full blur-2xl"
        animate={{
          x: [0, 40, 0],
          y: [0, 30, 0],
          scale: [1, 1.3, 1],
          opacity: [0.1, 0.4, 0.1]
        }}
        transition={{
          duration: 9,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 3
        }}
      />

      <motion.div
        className="absolute bottom-1/3 right-1/2 w-56 h-56 bg-gradient-to-r from-teal-200/15 to-cyan-300/15 rounded-full blur-2xl"
        animate={{
          x: [0, -30, 0],
          y: [0, -20, 0],
          scale: [1, 0.9, 1],
          opacity: [0.2, 0.5, 0.2]
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 4
        }}
      />

      {/* Subtle overlay for depth */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-t from-white/10 via-transparent to-white/5"
        animate={{
          opacity: [0.1, 0.3, 0.1]
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      {/* Animated mesh gradient */}
      <motion.div
        className="absolute inset-0 opacity-30"
        style={{
          background: `
            radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.1) 0%, transparent 50%)
          `
        }}
        animate={{
          opacity: [0.1, 0.3, 0.1],
          scale: [1, 1.05, 1]
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </div>
  );
};
